import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

import type {
    CartIconSettingsFormType,
    CartSettingsFormType,
    MiniCartSettingsFormType,
    ShopCartWidgetDataFormType,
} from '@web/widgets/shop-cart/type';
import { formAdditionalSettingsForm } from '@components/sp-form-additional-settings';
import { formButtonSettingsForm } from '@components/sp-form-button-settings';
import { formInputSettingsForm } from '@components/sp-form-input-settings';
import { analyticsSettingsFormGroup } from '@web/shared/components/web-analytics-settings/web-analytics-settings.form';

export const shopCartSettingsWidgetDataForm = (): FormGroup<CartSettingsFormType> =>
    new FormGroup<CartSettingsFormType>({
        previewSize: new FormControl(null),
        isSeparatedItems: new FormControl(null),
        separatorWidth: new FormControl(null),
        separatorType: new FormControl(null),
        separatorColor: new FormControl(null),
        itemTitleFontSize: new FormControl(null),
        itemTitleFontStyle: new FormArray([]),
        itemTitleFontColor: new FormControl(null),
        itemPropertyFontSize: new FormControl(null),
        itemPropertyFontStyle: new FormArray([]),
        itemPropertyFontColor: new FormControl(null),
        itemPriceFontSize: new FormControl(null),
        itemPriceFontStyle: new FormArray([]),
        itemPriceFontColor: new FormControl(null),
        itemTotalPriceFontSize: new FormControl(null),
        itemTotalPriceFontStyle: new FormArray([]),
        itemTotalPriceFontColor: new FormControl(null),
        deleteButtonIconColor: new FormControl(null),
        deleteButtonBgColor: new FormControl(null),
        countButtonColor: new FormControl(null),
        countButtonTextColor: new FormControl(null),
        countButtonBgColor: new FormControl(null),
        countButtonBorderColor: new FormControl(null),
        countButtonRounding: new FormControl(null),
        countButtonSize: new FormControl(null),
    });

export const shopCartIconSettingsWidgetDataForm = (): FormGroup<CartIconSettingsFormType> =>
    new FormGroup<CartIconSettingsFormType>({
        iconType: new FormControl(null),
        iconColor: new FormControl(null),
        iconBgColor: new FormControl(null),
        iconCounterColor: new FormControl(null),
        iconCounterBgColor: new FormControl(null),
        iconRounding: new FormControl(null),
        iconSize: new FormControl(null),
        iconPositionType: new FormControl(null),
    });

export const shopMiniCartSettingsWidgetDataForm = (): FormGroup<MiniCartSettingsFormType> =>
    new FormGroup<MiniCartSettingsFormType>({
        modalBackgroundColor: new FormControl(null),
        modalBorderRadius: new FormControl(null),
        separatorColor: new FormControl(null),
        textColor: new FormControl(null),
        priceColor: new FormControl(null),
        oldPriceColor: new FormControl(null),
        deleteButtonIconColor: new FormControl(null),
        deleteButtonBgColor: new FormControl(null),
        countButtonTextColor: new FormControl(null),
        countButtonBgColor: new FormControl(null),
        countButtonBorderColor: new FormControl(null),
        countButtonRounding: new FormControl(null),
        buttonBgColor: new FormControl(null),
        buttonTextColor: new FormControl(null),
        buttonBorderRadius: new FormControl(null),
        buttonSettings: formButtonSettingsForm(),
    });

export const shopCartWidgetDataFormGroup = (): FormGroup<ShopCartWidgetDataFormType> =>
    new FormGroup({
        createAddressBook: new FormControl(null),
        selectedAddressBook: new FormControl(null, [Validators.required]),
        selectedPipeline: new FormControl(null, [Validators.required]),
        selectedPipelineStep: new FormControl(null, [Validators.required]),
        selectedPipelineSettings: new FormControl(null),
        elements: new FormArray([]),
        paymentElements: new FormArray([]),
        dealName: new FormControl(null, [Validators.required]),
        paymentFormName: new FormControl(null, [Validators.required]),
        createContactAndDeal: new FormControl(null),
        inputSettings: formInputSettingsForm(),
        formButtonSettings: formButtonSettingsForm(),
        additionalFormSettings: formAdditionalSettingsForm(),
        cartSettings: shopCartSettingsWidgetDataForm(),
        cartIconSettings: shopCartIconSettingsWidgetDataForm(),
        miniCartSettings: shopMiniCartSettingsWidgetDataForm(),
        analyticsSettings: analyticsSettingsFormGroup(),
        cartViewType: new FormControl(null),
        items: new FormArray([]),
        addCrmTags: new FormControl(null),
        contactTags: new FormArray<FormControl<number>>([]),
        addAddressBookTags: new FormControl(null),
        contactAddressBookTags: new FormArray<FormControl<number>>([]),
    });
